import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { history, store } from "../../../../../store/store";
import { ROUTE_CLIENT_ORGANIZATIONS_VIEW } from "../../../../../config/routes";
import { ORGANIZATION_DELETE_STATUSES } from "../../../../../config/constants";
import { hideNotification } from '../../../../../store/actions/notification';

function ViewOrganization(props) {
  const { index, organization } = props;

  const shouldDisplay = (organization) => {
    return (! organization?.id || ORGANIZATION_DELETE_STATUSES.includes(organization?.status)) ? false : true;
  }

  if (! shouldDisplay(organization)) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`view-icon-${index}`}
        onClick={(e) => {
          e.preventDefault();
          store.dispatch(hideNotification());
          let url = ROUTE_CLIENT_ORGANIZATIONS_VIEW;
          url = url.replace(":organizationId", organization.id);
          history.push(url);
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${index}`}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage id="button.view" />
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { ViewOrganization };
